import {AdminAxios, AdverAxios} from "../../common/Axios";

const isInit = false;
const ACTION_URL = '/adver/dashboard/';
const OVERVIEW = 'overview';

/**
 * 플랫폼 현황 조회
 * @returns {Promise<null>}
 */
export async function retrieveOverview(param) {
  let returnVal = null;
  await AdminAxios('POST', ACTION_URL + OVERVIEW, param)
  .then((response) => {
    const { data, statusCode, message } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = null)
  return returnVal;
}

/**
 * 특정 광고주 광고 현황 조회
 * @param userId
 * @returns {Promise<null>}
 */
export async function retrieveAdverOverview(userId, param) {
  let returnVal = null;
  if (isInit) {
    return [
        {
          historyDate: 20250805,
          revenueAmount: 10,
          requestCount: 10,
          responseCount: 10,
          exposureCount: 10,
          validClickCount: 10,
          costAmount: 10
        }
      ]

    // return {
    //   rows: [
    //     {
    //       historyDate: 20250805,
    //       revenueAmount: 10,
    //       requestCount: 10,
    //       responseCount: 10,
    //       exposureCount: 10,
    //       validClickCount: 10,
    //       costAmount: 10
    //     }
    //   ], totalCount: 1
    // }
  }
  await AdverAxios('POST', '/dashboard/' + userId + '/' + OVERVIEW, param)
  .then((response) => {
    const { data, statusCode, message } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = null)
  return returnVal;
}

